var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { REFERRALS_ENDPOINTS } from '../constants/referrals';
import { queryVolumeByTrader } from '../queries/futures';
import { queryCodesByReferrer, queryTradersByCode } from '../queries/referrals';
const calculateTraderVolume = (futuresTrades) => {
    return futuresTrades.reduce((acc, trade) => {
        return acc + (Math.abs(+trade.size) / 1e18) * (+trade.price / 1e18);
    }, 0);
};
export const getReferralsGqlEndpoint = (networkId) => {
    return REFERRALS_ENDPOINTS[networkId] || REFERRALS_ENDPOINTS[10];
};
export const getReferralStatisticsByAccount = (sdk, account) => __awaiter(void 0, void 0, void 0, function* () {
    const codes = yield queryCodesByReferrer(sdk, account);
    return yield Promise.all(codes.map((code) => __awaiter(void 0, void 0, void 0, function* () {
        const traders = yield queryTradersByCode(sdk, code);
        const totalVolume = yield traders.reduce((accVolume, trader) => __awaiter(void 0, void 0, void 0, function* () {
            const volume = yield queryVolumeByTrader(sdk, trader.id, trader.lastMintedAt);
            return (yield accVolume) + calculateTraderVolume(volume);
        }), Promise.resolve(0));
        return {
            code,
            referredCount: traders.length.toString(),
            referralVolume: totalVolume.toString(),
            earnedRewards: '0',
        };
    })));
});
